export const MERCHANT_SETTINGS_FORM_ID = 'merchantSettings';
